const INIT = 'INIT'; // Start request
const REQUEST = 'REQUEST'; // Notify redux that request is loading.
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

export const createRequestTypes = base => (
  [INIT, REQUEST, SUCCESS, FAILURE].reduce((obj, type) => ({
    ...obj,
    [type]: `${base}_${type}`,
  }), {})
);

export const action = (type, payload = {}) => ({ type, ...payload });



// WEBPACK FOOTER //
// ./src/actions/index.js